import { z } from 'zod';
import { NewsAndOffersType, NewsAndOffersStatus } from '@/features/news-and-offers/types/news-and-offers-dto';
import { t } from 'i18next';

export const NewAndOfferManageFormSchema = z.object({  
  imageUrl: z
    .union([
      z.instanceof(File, { message: t('elements.form.imageUploader.error') }),
      z.string().min(1, t('elements.form.imageUploader.error'))
    ]),
  title: z
    .string()
    .min(1, t('elements.form.title.errorMin'))
    .max(60, t('elements.form.title.errorMax')),
  description: z
    .string()
    .min(1, t('elements.form.description.errorMin'))
    .max(500, t('elements.form.description.errorMax')),
  type: z
    .nativeEnum(NewsAndOffersType),
  status: z
    .nativeEnum(NewsAndOffersStatus)
    .optional(),
  startDate: z
    .date({ message: t('elements.form.startDate.error') }),
  endDate: z
    .date()
    .optional(),
}).refine(
  (data) =>
    data.startDate && data.endDate
      ? data.endDate >= data.startDate
      : true,
  {
    message: t('elements.form.datesDifference.error'),
    path: ['endDate'],
  },
);